import React, { type FC, type JSX } from 'react';
import { Icon } from '@/app/common/icons/Icon';
import { ArrowCircle, ArrowContainer } from './styled';

type ArrowProps = {
  isRightArrow?: boolean;
  handleArrowClick: (val: string) => void;
};

const Arrow: FC<ArrowProps> = (props): JSX.Element => {
  const { isRightArrow, handleArrowClick } = props;

  return (
    <ArrowContainer isRightArrow={isRightArrow} onClick={() => handleArrowClick(isRightArrow ? 'right' : 'left')}>
      <ArrowCircle>
        <Icon
          category="Arrows"
          name="icon-small-chevron-down"
          size={20}
          color="iconPrimary"
          alt={isRightArrow ? 'right' : 'left'}
        />
      </ArrowCircle>
    </ArrowContainer>
  );
};

export default Arrow;
